import { memo, useEffect, useState } from "react";
import RecentPromptsDesktop from "./Desktop/RecentPromptsDesktop";
const RecentPromptsBody = () => {
    return (
        <>
            <RecentPromptsDesktop />
        </>
    )
}
export default RecentPromptsBody;